export const PublicValidator = ({ children }) => {
    return children
}
